import { atom } from 'jotai';

import type { EwalletType } from '../../entities/enums';

export const eWalletsOptionAtom = atom<
  Array<{
    value: string;
    ewalletname: string;
  }>
>([]);

export const selectedEWalletOptionAtom = atom<EwalletType | ''>('');

export const validEwalletAtom = atom<boolean>(false);

export const accountNoOVOAtom = atom<string>('');

export const validAccNoOVOAtom = atom<boolean>(false);
